export function getGa4ItemListReferrel() {
    return sessionStorage.getItem('ga4ItemListReferrel');
}
export function setGa4ItemListReferrel(ga4ItemListReferrel) {
    if (!sessionStorage)
        return;
    sessionStorage.setItem('ga4ItemListReferrel', ga4ItemListReferrel);
    sessionStorage.removeItem('ga4ItemListReferrelContext');
}
;
export function getGa4ItemListReferrelContext() {
    return sessionStorage.getItem('ga4ItemListReferrelContext');
}
export function setGa4ItemListReferrelContextFromEvent(event) {
    const ecommerce = event && event.ecommerce;
    const item = ecommerce && Array.isArray(ecommerce.items) && ecommerce.items[0];
    const itemListId = (ecommerce === null || ecommerce === void 0 ? void 0 : ecommerce.item_list_id) || (item === null || item === void 0 ? void 0 : item.item_list_id);
    const itemListName = (ecommerce === null || ecommerce === void 0 ? void 0 : ecommerce.item_list_name) || (item === null || item === void 0 ? void 0 : item.item_list_name);
    if (!itemListId || !sessionStorage)
        return;
    sessionStorage.setItem('ga4ItemListReferrel', itemListId);
    sessionStorage.setItem('ga4ItemListReferrelContext', JSON.stringify({
        itemListId,
        itemListName,
        locationId: item === null || item === void 0 ? void 0 : item.location_id,
        index: item === null || item === void 0 ? void 0 : item.index,
    }));
}
